import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useState,
} from 'react'

interface Props {
  templateTooltip: boolean
  setTemplateTooltip: Dispatch<SetStateAction<boolean>>
}

const TemplateTooltip = ({
  children,
  templateTooltip,
  setTemplateTooltip,
}: PropsWithChildren<Props>) => {
  return (
    <>
      {' '}
      <img
        src="assets/img/icon_tooltip.png"
        alt="툴팁"
        className=" w-[20px] h-[20px] cursor-pointer"
        onClick={() => {
          setTemplateTooltip(true)
        }}
      />
      {templateTooltip && (
        <div
          className="flex flex-col p-[16px] md:p-[32px] gap-[10px] bg-white w-[300px] md:w-[366px] h-auto absolute border-[3px] border-main  rounded-[20px]
         -bottom-20 right-14 z-50 md:left-14 md:top-10 min-h-[605px] "
        >
          <p className="font-bold md:text-[24px] text-base flex md:items-center justify-between">
            영상 제목이란?
            <button
              onClick={() => {
                setTemplateTooltip(false)
              }}
              className="flex flex-col h-full"
            >
              <img
                src="assets/img/Icon_x.png"
                alt="icon_x"
                className="md:w-[24px] md:h-[24px] w-[25px] h-[25px]"
              />
            </button>
          </p>
          <p className=" md:leading-[19.2px] md:text-base  leading-[19.2px] text-[10px] text-left">
            아래 숏폼 화면 예시와 같이{' '}
            <span className="text-main font-bold">
              영상의 상단에 입력하신 제목이 들어가며,
            </span>
            {` `}20자 내외로 입력하시면 2줄로 표기됩니다.
          </p>

          <div className="flex justify-center gap-[10px]">
            <div className="flex flex-col gap-[10px]">
              <img
                src="assets/img/template_tooltip.png"
                alt="example"
                width={240}
                height={424}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default TemplateTooltip
